<template>
  <!-- 异常数据 -->
  <div>
    <HeadControl ref="headControl" :titleName="'异常数据'" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker" />
    <div class="wrap">
      <div class="top">
        <div class="top_left">
          <div class="image">
            <img :src="abnormalNum.itemIcon" />
          </div>
          <div class="title">
            <div class="total">异常总数</div>
            <div class="number">
              <span class="num">{{ abnormalNum.count }}</span>个
            </div>
          </div>
        </div>
        <div class="top_right" ref="abnormalNum"></div>
      </div>
      <div class="bottom" ref="abnormalType"></div>
    </div>
  </div>
</template>

<script>
import * as Urls from "@/helper/Urls";
import HeadControl from "@/components/HeadControl";
export default {
  data() {
    return {
      orgCode: "", //组织架构
      dataRange: [], // 时间
      abnormalNum: {}, //异常总数，发生中，已处理
      abnormalProgressList: [],
      abnormalTypeData: {},
      maxNum: 0,    //最大数量
      maxPercent: 0,   //百分比最大
      screenWidth: document.body.clientWidth,
      isH5: false
    };
  },
  components: {
    HeadControl,
  },
  methods: {
    init() {
      this.$refs.headControl.getDatas('month');
      this.$refs.headControl.getSysOrg();
    },
    // 获取组织架构ID
    changeVal(val) {
      this.orgCode = val;
      this.getAbnormalNum();
      this.getProjectAbnormalData();
    },
    // 日期改变
    changDate(val) {
      this.dataRange = val;
      this.getAbnormalNum();
      this.getProjectAbnormalData();
    },
    // 时间
    changePicker(val) {
      this.dataRange = val;
      this.getAbnormalNum();
      this.getProjectAbnormalData();
    },
    // 获取异常总数   发生中   已处理
    getAbnormalNum() {
      let url = Urls.getEchartsAbnormalReportDataBySource;
      let params = {
        orgCode: this.orgCode || "",
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "ABNROMAL_NUM",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.abnormalNum = server_data.data;
      });
    },
    // 获取异常类型图表数据
    getProjectAbnormalData() {
      let url = Urls.getEchartsAbnormalTypeReportItemData;
      let params = {
        orgCode: this.orgCode,
        startTime: this.dataRange.length ? this.dataRange[0] : "",
        endTime: this.dataRange.length ? this.dataRange[1] : "",
        itemCode: "ABNORMAL_TYPE",
      };
      this.$root.doPost(url, params, (server_data) => {
        // 用户没有登录
        if (!this.$root.isUserLogin(server_data)) {
          return;
        }

        // 应用错误
        if (server_data.error) {
          this.$root.showGlobalError(server_data.error);
          return;
        }
        this.abnormalTypeData = server_data.data;
      });
    },
    initAbnormalNumChart() {
      this.abnormalNumChart = this.$echarts.init(this.$refs.abnormalNum);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        grid: {
          left: this.isH5 ? 20 : 60,
          top: 32,
          right: this.isH5 ? 20: 60,
          bottom: 30,
        },
        xAxis: {
          show: false,
          type: "value",
        },
        tooltip:{
          trigger: 'item',
          formatter:(params) => {
            return `<div style="font-size:14px; padding:4px;">
                         <div>${params.name}：${this.abnormalNum.series[0].data[params.dataIndex]}个</div>
                         <div>占比：${params.value}%</div>
                     </div>`
          }
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              formatter: (val, index) => {
                let res = "";
                this.abnormalNum.series[0].data.forEach((item, i) => {
                  if (i == index) {
                    res = item;
                  }
                });
                return val + `（${res}个）`;
              },
              textStyle: {
                color: "#666666",
                fontSize: "14",
                lineHeight: 20,
              },
              padding: [0, 0, 40, 15],
              align: 'left',
              rich: {

              }
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: this.abnormalNum.yAxis.data,
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            position: "left",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#57b9ff",
                fontSize: "14",
              },
              padding: [0, 0, -40, 15],
              formatter: "({value}%)",
              align: 'left',
              rich: {}
            },
            data: this.abnormalNum.series[0].percent,
          },
        ],
        series: [
          {
            type: "bar",
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 10,
                color: "#57b9ff",
              }
            },
            barWidth: 10,
            data: this.abnormalNum.series[0].percent,
          },
          {
            type: "bar",
            silent: true,
            barWidth: 10,
            barGap: "-100%",
            data: this.abnormalProgressList,
            itemStyle: {
              normal: {
                color: "#eeeeee",
                barBorderRadius: 10,
              },
            },
          },
        ],
      };
      this.abnormalNumChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.abnormalNumChart.resize({width: this.screenWidth - 24}) : this.abnormalNumChart.resize();
      });
      this.isH5 ? this.abnormalNumChart.resize({width: this.screenWidth - 24}) : this.abnormalNumChart.resize();
    },
    initAbnormalTypeChart() {
      this.abnormalTypeChart = this.$echarts.init(this.$refs.abnormalType);
      const option = {
        textStyle: {
          fontFamily: 'PingFang-M'
        },
        title: {
          text: "异常类型",
          padding: this.isH5 ? [24, 0, 0, 20]:[24, 0, 0, 30],
          textStyle: {
            fontWeight: 'normal'
          }
        },
        grid: {
          left:  this.isH5? 24:33,
          top: 97,
          right:  this.isH5? 30:33,
          bottom: 29,
          containLabel: true,
        },
        opacity: 0.1,
        tooltip: {
          trigger: "axis",
          formatter: (params)=>{
            let message = ''
            params.reverse().forEach(function(item, index){
              if(item.seriesIndex == 1) {
                message += item.axisValue + ': ' + item.data + '个' + '<br>'
              }else{
                message += '占比: ' + item.data + '%'
              } 
            })
            return `<div style="padding: 5px 8px; font-size: 12px">${message}</div>`
          }
        },
        legend: {
          data: this.abnormalTypeData.legend,
          itemWidth: 40,
          itemHeight: 8,
          top: '20',
          left: this.isH5 ?'120' : '180',
          itemGap: 20,// 每个icon之间的距离（单位px）
          textStyle: {
              fontSize: '13',            
              height: 10,
                rich: {
                a: {
                  verticalAlign: 'middle',
                },
              }
          },      
        },
        xAxis: [
          {
            type: "category",
            data: this.abnormalTypeData.xAxis.data,
            axisPointer: {
              type: 'none'
            },
            zlevel: 5,
            // 分隔线
            splitLine: {
              show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? true : false,
              lineStyle:{
                color: '#ddd'
              }
            },
            axisLabel:{
              color:'#666',
              margin: 20
            }
          },
        ],
        yAxis: [
          {
            show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
            // 数据显示
            type: "value",
            name: "百分比",
            min: 0,
            max: this.maxPercent,
            splitNumber: 5,
            interval: this.maxPercent / 5,
            axisLabel: {
              formatter: "{value}%",
              margin: 20,
            },
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 65, 0, 0],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            splitLine:{
              show: false
            }
          },
          {
            show: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? false : true,
            type: "value",
            name: "数量（个）",
            min: 0,
            max: this.maxNum,
            splitNumber: 5,
            interval: this.maxNum / 5,
            // 坐标轴名称的文字样式
            nameTextStyle: {
              padding: [0, 0, 0, 60],
            },
            axisTick: {
              length: 16,
              lineStyle: {
                color: "#ddd",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              margin: 20,
              formatter: function(value) {
                return parseInt(value)
              }
            },
            splitLine:{
              lineStyle: {
                color: "#ddd",
              },
            }
          },
        ],
        series: [
          {
            name: this.abnormalTypeData.series[0].name,
            type: "bar",
            barWidth: "40%",
            data: this.abnormalTypeData.series[0].data,
            itemStyle: {
              normal: {
                color: 'rgba(87, 185, 255, 0.35)',
                borderColor:this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? 'rgba(87, 185, 255, 0)':'rgba(87, 185, 255, 1)',
              },
            },
            yAxisIndex: 0,
          },
          {
            name: this.abnormalTypeData.series[1].name,
            type: "line",
            symbol: "rect",
            symbolSize: 9,
            hoverAnimation: false,
            data: this.abnormalTypeData.series[1].data,
            itemStyle: {
              normal: {
                color: "#61d9ac",
                opacity: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1,
              },
              emphasis: {          //突出效果配置(鼠标置于拐点上时)
                borderWidth: 3,
                borderColor: '#61d9ac',
                color: '#61d9ac',
              },
            },
             lineStyle:{
              normal:{
                opacity: this.abnormalTypeData.series[1].data.reduce((a,b)=>a+b)===0 ? 0 : 1
              }
            },
            yAxisIndex: 1,
          },
        ],
      };
      this.abnormalTypeChart.setOption(option);
      window.addEventListener("resize", () => {
        this.isH5 ? this.abnormalTypeChart.resize({width: this.screenWidth - 24}) : this.abnormalTypeChart.resize();
      });
      this.isH5 ? this.abnormalTypeChart.resize({width: this.screenWidth - 24}) : this.abnormalTypeChart.resize();
    },
  },
  watch: {
    abnormalNum(newVal) {
      this.abnormalProgressList = [];
      if (newVal) {
        newVal.series[0].data.forEach((item, index) => {
          this.abnormalProgressList[index] = 100;
        });
        this.initAbnormalNumChart();
      }
    },
    abnormalTypeData(newVal) {
      if (newVal) {
        this.maxNum = Math.ceil(Math.max(...newVal.series[1].data) / 10) * 10
        this.maxPercent = Math.ceil(Math.max(...newVal.series[0].data) / 10) * 10
        this.initAbnormalTypeChart();
      }
    },
  },
  mounted() {
    if(this.$route.query.identification) {
      this.isH5 = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth; //实时宽度
        this.screenWidth = window.screenWidth;
      })();
    }; 
  }
};
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 0.29rem;
  .top {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 24px;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.1rem;
    .top_left {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 140px;
      width: 22%;
      border-right: 1px solid #ddd;
      .image {
        width: 75px;
        height: 75px;
        margin-right: 10%;
      }
      .title {
        width: 75px;
        height: 75px;
        line-height: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-bottom: none;
        .total {
          font-size: 14px;
          color: #666;
          margin-bottom: 12px;
        }
        .number {
          color: #333;
          .num {
            font-size: 26px;
          }
        }
      }
    }
    .top_right {
      width: 78%;
      height: 200px;
    }
  }
  .bottom {
    height: 490px;
    box-sizing: border-box;
    background-color: #fff;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.1rem;
  }
}
@media screen and (max-width: 768px){
  .wrap{
    width: calc(100% - 0.24rem);
    margin: 0 auto;
    margin-top: -0.05rem;
    .top{
      flex-direction: column;
      margin-bottom: 0.12rem;
      .top_left{
        width: calc(100% - 0.24rem);
        border: none;
        border-bottom: 1px solid #ddd;
        justify-content: space-around;
      }
      .top_right{
        width: 100%;
      }
    }
    .bottom{
      background-color: #fff !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// abnormalData.vue?2d1999c8